/* eslint-disable no-underscore-dangle */
import React from 'react'
import { useQuery } from '@apollo/client'
import VirtualBooth from '../virtual-booth/VirtualBoothPage'
import SpeakerDetail from '../speakers/SpeakerDetailPage'
import SessionDetail from '../sessions/SessionDetailPage'
import SeriesDetail from '../series/SeriesDetailPage'
import { useCurrentSession } from '../SessionProvider'

import api from '../../api/brightspot'
import SeriesPage from '../series/SeriesPage'

export default function PreviewRedirector({ previewId }) {
  // This is for content creators in brightspot.  The cms passes something like this and wants to automagically load the right content via content id
  // https://beta.familysearch.org/rootstech/rtc2021?previewId=00000176-2e38-d90f-a3fe-7fb80d050000&typename=org_ldschurch_rootstech_model_ExhibitorPageViewModel&deviceWidth=1280
  const { model, setModel } = useCurrentSession()

  const { data } = useQuery(api.home.previewLookupGQLQuery(previewId))

  const components = {
    exhibitorpage: VirtualBooth,
    creator: SpeakerDetail,
    classsessionpage: SessionDetail,
    series: SeriesDetail,
    languagevideopage: SessionDetail,
    traditionsandholidayspage: SessionDetail,
    tipsandtrickspage: SessionDetail,
    genealogyrevealpage: SessionDetail,
    virtualtourpage: SessionDetail,
    yourhometownpage: SessionDetail,
    recipepage: SessionDetail,
    fashionshowpage: SessionDetail,
    howtodancepage: SessionDetail,
    oneoffpage: SeriesPage, // Series page is the priority right now.  There will be other subtypes of OneOffPage.
  }
  let selectedComponent

  if (data?.RootsTechPageEntry?.__typename) {
    const componentType = data.RootsTechPageEntry.__typename.toLowerCase()
    selectedComponent = components[componentType]
    if (!model) {
      setModel(data.RootsTechPageEntry.__typename)
    }
  }

  const ReturnedComponent = selectedComponent
  return ReturnedComponent ? <ReturnedComponent previewId={previewId} /> : null
}
